import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "units-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Completed Units", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Offline Mode ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " If you are experiencing a bug with the app, please include the following information: actions taken, expected result, actual result, and any other relevant information. ", -1)
const _hoisted_7 = { class: "center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_text = _resolveComponent("input-text")!
  const _component_Button = _resolveComponent("Button")!
  const _component_spacer_break = _resolveComponent("spacer-break")!
  const _component_image_upload = _resolveComponent("image-upload")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_saved_codes_list = _resolveComponent("saved-codes-list")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_text_area = _resolveComponent("text-area")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.storageUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_input_text, {
            modelValue: _ctx.inputUser,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputUser) = $event)),
            type: "text",
            class: "full p-inputtext-lg",
            placeholder: "User name"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Button, {
            onClick: _ctx.onSaveUser,
            label: "Save User Name",
            class: "full p-button-lg"
          }, null, 8, ["onClick"]),
          _createVNode(_component_spacer_break)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.storageJob)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_input_text, {
            modelValue: _ctx.inputJob,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputJob) = $event)),
            type: "text",
            class: "full p-inputtext-lg",
            placeholder: "Property name"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Button, {
            onClick: _ctx.onSaveJob,
            label: "Start New Property",
            class: "full p-button-lg"
          }, null, 8, ["onClick"]),
          _createVNode(_component_spacer_break)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_input_text, {
      modelValue: _ctx.unitName,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.unitName) = $event)),
      type: "text",
      class: "full p-inputtext-lg",
      placeholder: "Unit"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_spacer_break),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.greenCodes, (code) => {
      return (_openBlock(), _createElementBlock("div", { key: code }, [
        _createVNode(_component_Button, {
          onClick: ($event: any) => (_ctx.onAddCode(code)),
          label: code,
          class: _normalizeClass(["full p-button-lg", _ctx.chosenCodes.includes(code) ? 'p-button-secondary' : ''])
        }, null, 8, ["onClick", "label", "class"]),
        _createVNode(_component_spacer_break)
      ]))
    }), 128)),
    _createVNode(_component_Button, {
      onClick: _ctx.onAddCodes,
      label: "Add Codes",
      class: "full p-button-lg p-button-success"
    }, null, 8, ["onClick"]),
    _createVNode(_component_spacer_break),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yellowCodes, (code) => {
      return (_openBlock(), _createElementBlock("div", { key: code }, [
        _createVNode(_component_Button, {
          onClick: ($event: any) => (_ctx.onAddCode(code)),
          label: code,
          class: _normalizeClass(["full p-button-lg", _ctx.chosenCodes.includes(code) ? 'p-button-secondary' : 'p-button-warning'])
        }, null, 8, ["onClick", "label", "class"]),
        _createVNode(_component_spacer_break)
      ]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.redCodes, (code) => {
      return (_openBlock(), _createElementBlock("div", { key: code }, [
        _createVNode(_component_Button, {
          onClick: ($event: any) => (_ctx.onAddCode(code)),
          label: code,
          class: _normalizeClass(["full p-button-lg", _ctx.chosenCodes.includes(code) ? 'p-button-secondary' : 'p-button-danger'])
        }, null, 8, ["onClick", "label", "class"]),
        _createVNode(_component_spacer_break)
      ]))
    }), 128)),
    _createVNode(_component_spacer_break),
    _createVNode(_component_image_upload, {
      ref: "imageUpload",
      unitId: _ctx.unitName,
      job: _ctx.storageJob,
      onImageSelected: _ctx.onImageSelected
    }, null, 8, ["unitId", "job", "onImageSelected"]),
    _createVNode(_component_spacer_break),
    _createVNode(_component_Button, {
      onClick: _ctx.onAddCodes,
      label: "Add Codes",
      class: "full p-button-lg p-button-success"
    }, null, 8, ["onClick"]),
    _createVNode(_component_spacer_break),
    _createVNode(_component_Button, {
      onClick: _ctx.onEndJob,
      label: "End Job",
      class: "full p-button-lg p-button-help"
    }, null, 8, ["onClick"]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("span", null, [
        _hoisted_5,
        _createVNode(_component_checkbox, {
          class: "offline-checkbox",
          modelValue: _ctx.offlineMode,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.offlineMode) = $event)),
          binary: true
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_saved_codes_list, {
      codes: _ctx.visibleCodes,
      onSyncCode: _ctx.onSyncCode,
      syncing: _ctx.syncing,
      onDeleteCode: _ctx.onDeleteCode
    }, null, 8, ["codes", "onSyncCode", "syncing", "onDeleteCode"]),
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_ctx.version) + "      ", 1),
      _createElementVNode("i", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.displayBugForm = true)),
        onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.displayBugForm = true)),
        class: "pi pi-prime"
      }, null, 32)
    ]),
    _createVNode(_component_Dialog, {
      header: "Other description",
      visible: _ctx.displayOtherDesc,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.displayOtherDesc) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_input_text, {
          type: "text",
          modelValue: _ctx.otherDesc,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.otherDesc) = $event)),
          class: "full p-inputtest-lg"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_spacer_break),
        _createVNode(_component_Button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.displayOtherDesc = false)),
          label: "Save",
          class: "full p-button-lg"
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      header: "Report Bug",
      visible: _ctx.displayBugForm,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.displayBugForm) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_6,
        _createVNode(_component_text_area, {
          type: "text",
          modelValue: _ctx.bugDesc,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.bugDesc) = $event)),
          class: "full p-inputtest-lg modal-height",
          placeholder: "Describe the bug"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_spacer_break),
        _createVNode(_component_Button, {
          onClick: _ctx.onSubmitBug,
          label: "Submit",
          class: "full p-button-lg"
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_BlockUI, {
      blocked: _ctx.loading,
      "full-screen": true
    }, null, 8, ["blocked"]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createVNode(_component_ProgressSpinner)
    ], 512), [
      [_vShow, _ctx.loading]
    ])
  ], 64))
}